import { executeRequest, Request, Response } from '@jfs/network'
import { Config } from 'react-native-config'
import { convertBoolValue, getBillId } from '../util/billPaymentUtil'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: Response, categoryMasterId: number) => {
  const responseData = data?.data?.responseObject ?? []
  if (data.data.responseStatus?.code === '000') {
    const retData = responseData?.map((item: any) => {
      const billId = getBillId(item.product.id, item?.beneficiary?.authenticators ?? [])
      return {
        id: `fav_${billId}`,
        amount: item.payment.amountDetails.amount ?? '', //TODO: Need to change correct property
        billerShortName: item?.product?.name ?? '',
        operatorId: item?.product?.id ?? 0,
        categoryId: categoryMasterId,
        authenticators: item?.product?.attribute?.authenticatorList ?? [],
        labelOfAuthenticators: [],
        customerBillerAccountId: item?.beneficiary?.id ?? null,
        shortName: item?.product?.displayName,
        siStatus: false,
        billPresentConsent: convertBoolValue(item?.beneficiary?.billPresentConsent),
        billPresentConsentDisplay: convertBoolValue(item?.beneficiary?.billPresentConsentDisplay),
        lastTxnRefNo: item?.beneficiary?.lastTxnRefNo ?? '',
        circleId: item?.circleDetails?.id,
        circleName: item?.circleDetails?.name,
      }
    })
    return retData
  } else {
    const errorMsg = {
      errorCode: data?.data?.error?.code,
      errorMessage: data?.data?.error?.message,
    }
    throw errorMsg
  }
}

const returnBody = (categoryMasterId: number, operatorId: number) => {
  return {
    category: {
      id: categoryMasterId,
    },
    product: {
      id: operatorId,
    },
    domain: {
      id: 'PayMyBill',
      name: 'PayMyBill',
      transactionType: 'BUY',
      description: 'This is for the buy case',
    },
    initiatingEntity: {
      entityId: Config.REACT_APP_CHANNEL_ID,
      channelId: Config.REACT_APP_CHANNEL_ID,
    },
  }
}

const getFavouriteTransaction = (tokens, userAccessToken, categoryMasterId: number, operatorId: number) => {
  const config = sitConfig(tokens)
  //config.baseUrl = Config.REACT_APP_JFS_BASE_URL
  const request: Request<{}> = {
    apiPath: APIEndPoints.getSpinnerList,
    method: 'POST',
    config: config,
    body: returnBody(categoryMasterId, operatorId),
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
  }
  return executeRequest(request)
    .then((data) => responseParser(data, categoryMasterId))
    .catch((error) => {
      throw error
    })
}
export { getFavouriteTransaction }
